export type VibrationPattern = number | Iterable<number>;

/**
 * Whether the current runtime supports navigator vibration.
 */
export function canVibrate() {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

/**
 * Trigger haptic feedback when the browser supports the Vibration API.
 * Returns false when unsupported or when the browser rejects the pattern.
 */
export function triggerVibration(pattern: VibrationPattern) {
  if (!canVibrate()) return false;

  const normalizedPattern = typeof pattern === "number" ? [pattern] : pattern;
  return navigator.vibrate(normalizedPattern);
}
